import React from 'react';
import styled from 'styled-components';

import ButtonDefault from './Buttons';

const InputGroupWrapper = styled.div`
  display: flex;
  margin-top: 10px;
`;

const StyledList = styled.ul`
  list-style-type: none;
  padding-left: 0;
`;

export type EditableListProps = {
  itemList: RowItem[];
  setListData: (data: RowItem[] | ((data: RowItem[]) => RowItem[])) => void;
  getBlankItemData?: () => RowItem;
  canAdd?: boolean;
  canDelete?: boolean;
  isDisabled?: boolean;
};

export type RowItem = {
  key: string;
  rowElement: React.ReactNode;
};

export const EditableList: React.FC<EditableListProps> = ({
  itemList,
  setListData,
  getBlankItemData,
  isDisabled = false,
  canAdd = !isDisabled,
  canDelete = !isDisabled,
}) => {
  const handleRemove = (id: string) => {
    setListData(itemList.filter(item => item.key !== id));
  };

  const handleAdd = () => {
    if (canAdd && getBlankItemData) {
      const blankItem = getBlankItemData();
      setListData([...itemList, blankItem]);
    }
  };

  return (
    <>
      <StyledList>
        <fieldset disabled={isDisabled}>
          {itemList.map(row => (
            <li key={row.key}>
              <InputGroupWrapper>
                {row.rowElement}
                {canDelete && (
                  <ButtonDefault
                    id="removeButton"
                    onClick={() => handleRemove(row.key)}
                  >
                    Remove
                  </ButtonDefault>
                )}
              </InputGroupWrapper>
            </li>
          ))}
        </fieldset>
      </StyledList>

      {canAdd && getBlankItemData && (
        <ButtonDefault id="addButton" onClick={() => handleAdd()}>
          Add
        </ButtonDefault>
      )}
    </>
  );
};
